import { useGenericRequestHandler } from '../../handlers'

export const useActivityExportMutation = () => {
  return useGenericRequestHandler({
    route: 'v1/a/createCSV',
    method: 'POST'
  })
}
